export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const SELECT_AVATAR = 'SELECT_AVATAR';
export const RECENTLY_PLAYED_GAME = 'RECENTLY_PLAYED_GAME';
export const CNPUSH_ENABLED = 'CNPUSH_ENABLED';
export const HIDE_BADGGE = 'HIDE_BADGGE';

export const login = payload => {
    return {
        type: USER_LOGIN,
        payload: {
            ...payload,
            token: true,
        },
    };
};

export const logout = () => {
    return {
        type: USER_LOGOUT,
    };
};

export const selectAvatar = avatarIndex => {
    return {
        type: SELECT_AVATAR,
        payload: {
            avatarIndex,
        },
    };
};

export const saveGamePlayed = gameId => {
    return {type: RECENTLY_PLAYED_GAME, gameId};
};

export const togglePush = enabled => {
    return {type: CNPUSH_ENABLED, enabled};
};

export const hideBadge = () => {
    return {type: HIDE_BADGGE};
};
